import React from "react"

export interface AmountProps {
  amount: number
  decimals?: number
}

export const Amount: React.FC<AmountProps> = ({amount, decimals = 2}) => {
  return <>{toAmount(amount, decimals)}</>
}

export const toAmount = (amount: number, decimals: number = 2): string => {
  return `€ ${toFormattedNumber(amount, decimals)}`
}

export const toPercentage = (factor: number, decimals: number = 2): string => {
  return `${toFormattedNumber(factor * 100, decimals)}%`
}


export const toFormattedNumber = (amount: number, decimals: number = 2): string => {
  const formatter = new Intl.NumberFormat("nl-NL", {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals
  })
  return formatter.format(amount)
}